export default "__VITE_ASSET__BPtWMecE__"